// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"DraggableList_fullWidth_2PVzi"};